import { hbs } from 'ember-cli-htmlbars';
export default hbs("{{page-title \"VOLTA\"}}{{outlet}}<BvFlashContainer @position=\"bottom-right\" />")